import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { IPrescription } from '../Prescription.ts';
import { PrescriptionApi } from '../../../apis/PrescriptionApi/PrescriptionApi.ts';
import { patientStore } from '../../../Store/Store.ts';
import { useSessionProvider } from '../../../provider/sessionContext.tsx';

export function usePutPrescription() {
    const { currentUser } = useSessionProvider();

    const resolvedPatientId: string | undefined = patientStore?.patientId || currentUser?.patientID;

    return useMutation<number, AppMedError, IPrescription[]>({
        mutationKey: [QueryKeys.prescription, resolvedPatientId],
        mutationFn: async (variables) => {
            if (!resolvedPatientId) 
                throw new Error('Patient ID is required');
            
            return (await PrescriptionApi.putPrescription(resolvedPatientId, variables)) ?? 0;
        },
    });
}
